module.exports = __webpack_public_path__ + "img/background_6.dac21504.jpg";